





















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import Section0 from "@/components/subcomponents/SectionBloom.vue";
import Section1 from "@/components/subcomponents/SectionFonctionnalite.vue";
import Section2 from "@/components/subcomponents/SectionPerformance.vue";
import Section3 from "@/components/subcomponents/SectionPubCiblee.vue";

@Component({
  components: {
    Section0,
    Section1,
    Section2,
    Section3,
  },
})
export default class Modale extends Vue {
  @Prop({ default: {} }) readonly Config: any;
}
